<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10Ujh0t/tc-custom/9781466833043.jpg?1731160442084" alt="This image is the cover for the book Magician and the Cardsharp"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Magician and the Cardsharp
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A famous magician's journey to find the greatest cardsharp ever evokes the forgotten world of magic where Americans found escape during the Great Depression</b><br/><br/>It has the nostalgic quality of an old-fashioned fable, but Karl Johnson's <i>The Magician and the Cardsharp</i> is a true story that lovingly re-creates the sparkle of a vanished world. Here, set against the backdrop of America struggling through the Depression, is the world of magic, a realm of stars, sleight of hand, and sin where dreams could be realized - or stolen away. <br/><br/>Following the Crash of '29, Dai Vernon, known by magicians as "the man who fooled Houdini," is tramping down Midwestern backroads, barely making ends meet. While swapping secrets with a Mexican gambler, he hears of a guy he doesn't quite believe is real - a legendary mystery man who deals perfectly from the center of the deck and who locals call the greatest cardsharp of all time. Determined to find the reclusive genius, Vernon sets out on a journey through America's shady, slick, and sinful side - from mob-run Kansas City through railroad towns that looked sleepy only in the daytime. Does he find the sharp? <br/><br/>Well, Karl Johnson did - after years of research into Vernon's colorful quest, research that led him to places he never knew existed. Johnson takes us to the cardsharp's doorstep and shows us how he bestowed on Vernon the greatest secret in magic. <i>The Magician and the Cardsharp</i> is a unique and endlessly entertaining piece of history that reveals the artistry and obsession of a special breed of American showmen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karl Johnson
      </h2>
      
      <p class="authorDescription body article"><P>Karl Johnson, a former editor at the <I>New York Daily News</I>, has written for many major newspapers and periodicals. <I>The Magician and the Cardsharp</I> grew out of an article published in <I>American Heritage </I>magazine. He lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b82756b4